<template>
  <div>
    <div class="fa">
      <img v-if="error" src="../assets/pic/error.png" alt="" />

      <!--span slot="reference">失败</!--span-->
      <!-- <el-button @click="closeDown">关闭</el-button> -->
      <p style="width:200px;" v-if="error">错误信息：{{error}}</p>
      <h1 style="width:auto;font-size: 80px;text-align: left;padding: 0 10px;" v-else>404 Not Found</h1>
      <!-- <el-button size="mini" @click="exit">退 出</el-button> -->
    </div>
  </div>
</template>
<script>
export default {
  beforeMount() {
    this.error = decodeURIComponent(decodeURIComponent(window.location.search));
    //  this.error = "123"
  },
  data() {
    return {
      error: "",
      error2: "",
      error3: ""
    };
  },
  methods: {
    closeDown() {
      /* eslint-disable */
      WeixinJSBridge.call("closeWindow");
      android.finishActivity();
      setTimeout(function() {
        //这个可以关闭安卓系统的手机
        document.addEventListener(
          "WeixinJSBridgeReady",
          function() {
            WeixinJSBridge.call("closeWindow");
          },
          false
        );
      });
    }
  }
};
</script>
<style scoped>
.fa {
  /* width: 202px;
  height: 250px; */
  width: calc(100% - 0);
  height: calc(100vh);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background-color: rgb(255, 168, 168); */
}
img {
  width: 200px;
  height: 200px;
}
span {
  width: 200px;
  height: 50px;
  display: inline-block;
  overflow: hidden;
  text-align: center;
  font-size: 24px;
}
.el-button {
  width: 200px;
}
</style>
